import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  open: boolean;
  roomTitle?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteRoomDialog({ open, roomTitle, onClose, onConfirm }: Props) {
  const roomName = roomTitle || 'this room';

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete room?</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete {roomName}? This action cannot be undone.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
